module.exports = __webpack_public_path__ + "static/avatar-90620a5e5100b3c5477e1aef4f43ca7f.jpg";